import { Action, ThunkDispatch } from '@reduxjs/toolkit';

import { EntityType } from '@frontend/common';
import { useResolver } from '@frontend/repository';
import { StockClient } from '@frontend/stock/api';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useStock:request': CustomEvent<string>;
    }
}

const REQUEST_STOCK_EVENT = 'useStock:request';
const STORAGE_KEY = 'STOCK_REQ';

export function stockRequest(stockId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_STOCK_EVENT, { detail: stockId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function StockResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_STOCK_EVENT, EntityType.STOCK, (ids) => StockClient.resolveStocks(ids), props.dispatch);
    return <></>;
}
